function extractObjectSubset(keys: string[], sourceObj: any): any {
  const newObj = {};
  keys.forEach((key) => {
    if (key in sourceObj) {
      // @ts-ignore
      newObj[key] = sourceObj[key];
    }
  });
  return newObj;
}

export default extractObjectSubset;
